import React from 'react';
import { http, ConfigContext } from '../../base-ui/lib.js';

interface Document {
	contentType: string;
	createdAt: string;
	documentId: string;
	documentName: string;
	modifiedAt: string;
	path: string;
	[key: string]: any; // For any additional properties
}

export function ListDocuments() {
	const { config }: any = React.useContext(ConfigContext);
	const [documents, setDocuments] = React.useState<Document[]>([]);

	async function fetchDocuments() {
		try {
			const response = await http.get({}, `${config.uri.base}/esign/list`);
			setDocuments(response.documents);
		} catch (error) {
			console.error('Error fetching documents:', error);
		}
	}

	React.useEffect(() => {
		fetchDocuments();
	}, [config.uri.base]);

	async function handleDelete(documentId: string) {
		try {
			await http.delete({}, `${config.uri.base}/esign/delete/${documentId}`);
			await fetchDocuments();
		} catch (error) {
			console.error('Error deleting document:', error);
		}
	}

    async function handleDowndload(documentId: string) {
        try {
            const response = await http.get({}, `${config.uri.base}/esign/download/${documentId}`, {
                responseType: 'arraybuffer',
            });
            const url = window.URL.createObjectURL(new Blob([response], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `document-${documentId}.docx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        catch (error) {
            console.error('Error downloading document:', error);
        }
    }

	return (
		<div>
			<h1>List of Documents</h1>
			<div className="flex flex-wrap gap-4">
				{documents?.map((doc) => (
					<div
						key={doc.documentId}
						className="border border-gray-300 rounded-lg p-4 min-w-[220px] shadow-sm flex flex-col items-start bg-white"
					>
						<div className="font-bold mb-2">{doc.documentName}</div>
						<div className="mb-4 text-gray-500">{doc.contentType}</div>
						<div className="flex gap-2">
							<button
								className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
								onClick={() => alert(`Update ${doc.documentName}`)}
							>
								Update
							</button>
							<button
								className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 transition"
								onClick={handleDelete.bind(null, doc.documentId)}
							>
								Delete
							</button>
							<button
								className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600 transition"
								onClick={handleDowndload.bind(null, doc.documentId)}
							>
								Download
							</button>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
